import * as React from 'react'
import { PromoPopups } from './client-popups'
import { useFeatureIsOn } from 'growthbook'

const FreebiesPopup = React.lazy(() =>
  import('./types/freebies-popup').then(m => ({ default: m.FreebiesPopup })),
)

const FavoritePopup = React.lazy(() =>
  import('./types/favorite-popup').then(m => ({ default: m.FavoritePopup })),
)

export function Popups() {
  const favoritePopupFlag = useFeatureIsOn('favorite-popup')
  return (
    <>
      <React.Suspense fallback={null}>
        <FreebiesPopup />
        <PromoPopups />
        {favoritePopupFlag ? <FavoritePopup /> : null}
      </React.Suspense>
    </>
  )
}
